exelare_jobs.define('main_button',[], function () {
    return function ($, ko, root) {
        //loading job list template
        root.container.append("<button class='btn btn-primary btn-sm' data-bind='click: applyJob'>Submit Resume</button>");
        var ViewModel = function () {
            this.applyJob = function () {
                var formModal = $('#appFormModal');
                var appFormMdl = new root.AppFormModel(null);

                ko.cleanNode(formModal[0]);
                ko.applyBindings(appFormMdl, formModal[0]);
                formModal.modal('show');
                $('#exelare_jobs_container .input-group.date').datepicker({});
            };
        }
        ko.applyBindings(new ViewModel(), container[0]);

        $.get(root.ExelareSettings.mapPathOf("applicationFormTemplate"), function (html) {
            container.append(html);
        });
    }
});
